export const enLang = {
  languageKey: 'en',
  translates: {},
};
